import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Mobile, Desktop } from 'app/components/Responsive';

import DishDetailsSubtitle from './DishDetailsSubtitle';
import DishDetailsInnerBlock from './DishDetailsInnerBlock';

import './dish-details.scss';

// eslint-disable-next-line react/prop-types
const TextLine = ({ children }) => {
    const num = /(\d+)/g;
    const fragments = children.split(num);
    return (
        <>
            {fragments.map((fragment) => {
                if (num.test(fragment)) {
                    return <span key={fragment} styleName="num">{fragment}</span>;
                }
                return fragment;
            })}
        </>
    );
};

// eslint-disable-next-line react/prop-types
const TextLines = ({ children }) => {
    const isMultiLineContent = Array.isArray(children);

    if (!isMultiLineContent) {
        return <TextLine>{children}</TextLine>;
    }

    return (
        <>
            {children.map((line) => (
                <Fragment key={line}>
                    <TextLine>{line}</TextLine>
                    <br />
                </Fragment>
            ))}
        </>
    );
};


export default function DishDetailsTable({ table }) {
    const isNededRenderTitles = table.length > 1;

    const [tableParams] = table;

    const hideDefaultHeading = tableParams?.hideDefaultHeading;
    const generalTitle = tableParams?.generalTitle;
    const heading = generalTitle || 'Что в наборе?';

    return (
        <>
            {!hideDefaultHeading ? (
                <>
                    <Mobile isWideMobile>
                        <DishDetailsInnerBlock type="h3">
                            <DishDetailsSubtitle>
                                {heading}
                            </DishDetailsSubtitle>
                        </DishDetailsInnerBlock>
                    </Mobile>

                    <Desktop isWideMobile>
                        <DishDetailsInnerBlock type="h2-1">
                            <DishDetailsSubtitle>
                                {heading}
                            </DishDetailsSubtitle>
                        </DishDetailsInnerBlock>
                    </Desktop>
                </>
            ) : (
                <DishDetailsInnerBlock type="content" />
            )}

            {table.map(({ title, list }) => (
                <Fragment key={title}>
                    {isNededRenderTitles && (
                        <DishDetailsInnerBlock type="h3">
                            <DishDetailsSubtitle asHtml={false} small>
                                <TextLines>
                                    {title}
                                </TextLines>
                            </DishDetailsSubtitle>
                        </DishDetailsInnerBlock>
                    )}

                    <div styleName="ny__details__table">
                        {list.map((i) => {
                            const amountText = i.amount || ' ';
                            const unitText = i.unit || null;
                            const nameText = Array.isArray(i.name) ? i.name.join(' ') : i.name;

                            const classes = `ny__details__name-cell ${i.className || ''}`;

                            return (
                                <div styleName="ny__details__row" key={i.name}>
                                    {i.nameType === 'html'
                                        ? (
                                            <div
                                                styleName={classes}
                                                dangerouslySetInnerHTML={{ __html: nameText }}
                                            />
                                        ) : (
                                            <div styleName={classes}>
                                                {/* <TextLines> */}
                                                {nameText}
                                                {/* </TextLines> */}
                                            </div>
                                        )
                                    }

                                    <div styleName="ny__details__amount-cell">
                                        <span styleName="num">{amountText}</span>
                                        &nbsp;
                                        {unitText}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Fragment>
            ))}
        </>
    );
}

DishDetailsTable.propTypes = {
    table: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
            list: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
                    amount: PropTypes.string,
                    unit: PropTypes.string,
                }),
            ).isRequired,
        }),
    ).isRequired,
};
